export { default } from './ThumbsUp'
